export enum JobExperienceType {
  experience0,
  experience1,
  experience2,
  experience3,
  experience4,
  experience5
}